import React from "react";
import { Button, Col, Form, FormGroup, Row, Label, Input } from "reactstrap";
import { UserService } from "../../../../services/UserService";

interface UpdateAccountProps {
  email: string;
  successCb?: (newEmail: string) => void;
}

// eslint-disable-next-line react/display-name
export const UpdateAccount: React.FunctionComponent<UpdateAccountProps> = React.memo((props: UpdateAccountProps) => {
  // form actions
  const [submitted, setSubmitted] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const [errored, setErrored] = React.useState("");
  const [formErrors, setFormErrors] = React.useState(null);

  // form fields
  const [email, setEmail] = React.useState(props.email);

  const checkFormErrors = (name: string, value: string) => {
    let error;
    switch (name) {
      case "email":
        error = value && /^[\w%+.-]+@[\d.a-z-]+\.[a-z]{2,10}$/i.test(value) ? "" : "Email is not valid!";
        break;
      default:
        break;
    }
    return error;
  };
  const validateForm = () => {
    let valid = true;
    const errors = {} as any;
    errors.email = checkFormErrors("email", email);
    Object.keys(errors).forEach(
      // if we have an error string set valid to false
      (p: any) => {
        if (errors[p] && errors[p].length > 0) {
          valid = false;
        }
      },
    );
    return { valid, errors };
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    try {
      setSubmitting(true);
      setErrored("");
      const myForm = validateForm();
      if (!myForm.valid) {
        setSubmitting(false);
        setFormErrors(myForm.errors);
        return;
      }
      const values = {
        email,
      };
      await UserService.updateAccount(values);
      if (props.successCb) {
        props.successCb(values.email);
      }
      setSubmitted(true);
    } catch (error: any) {
      console.error(error.err);
      if (error.err) {
        setErrored(error.err.map((e: string) => `${e}\n`));
      } else {
        setErrored("There was an issue submitting your change, please try again");
      }

      setSubmitting(false);
    }
  };
  // tslint:disable:max-line-length
  return (
    <div className="update-account">
      {!submitted && (
        <div>
          <Row>
            <Col xs="12">
              <Form role="form" className="update-account" onSubmit={handleSubmit}>
                <Row>
                  <Col xs="12">
                    <FormGroup className="mb-3">
                      <Label for="name" id="lbl-email">
                        Email:
                      </Label>
                      <Input
                        type="text"
                        autoComplete="email"
                        name="email"
                        value={email}
                        placeholder="Email"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      {formErrors && formErrors.email && (
                        <div className="has-error">
                          <div className="form-feedback">{formErrors.email}</div>
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" className="text-center">
                    <Button id="btn-submit" color={"secondary"} type="submit" disabled={submitting}>
                      Update
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
          <Row>
            <Col xs="12">
              {errored && (
                <FormGroup>
                  <div className="form-feedback">{errored}</div>
                </FormGroup>
              )}
            </Col>
          </Row>
        </div>
      )}
      {!props.successCb && submitted && <div className="text-center">We updated your account info.</div>}
    </div>
  );
});
